export const DATA_ATTRIBUTE = 'data-row-id';
export const EDITABLE_TABLE_TITLE_INPUT_ID = 'EDITABLE_TABLE_TITLE_INPUT';

export const getRowElement = (id: string): HTMLDivElement | null =>
  document.querySelector(`[${DATA_ATTRIBUTE}="${id}"]`) as HTMLDivElement | null;

export const focusRowElement = (id: string) => {
  const el = getRowElement(id);
  if (el) {
    el.focus();
  }
};

export const blurRowElement = (id: string) => {
  const el = getRowElement(id);
  if (el) {
    el.blur();
  }
};

export const selectRowInputText = (id: HTMLBaseElement['id']) => {
  requestAnimationFrame(() => {
    const input = document.getElementById(id) as HTMLInputElement;
    if (input) {
      input.select();
    }
  });
};
